/**
 * @generated SignedSource<<2747b55a4c8a971390db4f21b89de2db>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TrackViewEvent = "DIRECT" | "INDIRECT" | "SKIP";
export type ProjectViewAsideQuery$variables = {
  areMilestonesEnabled: boolean;
  cloudId?: string | null;
  isNavRefreshEnabled: boolean;
  key: string;
  trackViewEvent?: TrackViewEvent | null;
  workspaceId?: string | null;
};
export type ProjectViewAsideQuery$data = {
  readonly currentUser: {
    readonly aaid: string | null;
  } | null;
  readonly project?: {
    readonly members: {
      readonly " $fragmentSpreads": FragmentRefs<"utils_isUserInList">;
    } | null;
    readonly owner: {
      readonly aaid: string | null;
    } | null;
    readonly private: boolean;
    readonly watchers: {
      readonly " $fragmentSpreads": FragmentRefs<"utils_isUserInList">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectSidebar">;
  } | null;
};
export type ProjectViewAsideQuery = {
  response: ProjectViewAsideQuery$data;
  variables: ProjectViewAsideQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "areMilestonesEnabled"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isNavRefreshEnabled"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "key"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "trackViewEvent"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v6 = {
  "kind": "Variable",
  "name": "key",
  "variableName": "key"
},
v7 = [
  (v6/*: any*/),
  {
    "kind": "Variable",
    "name": "trackViewEvent",
    "variableName": "trackViewEvent"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "aaid"
},
v9 = [
  (v8/*: any*/)
],
v10 = {
  "kind": "ScalarField",
  "name": "private"
},
v11 = [
  {
    "kind": "InlineDataFragmentSpread",
    "name": "utils_isUserInList",
    "selections": [
      {
        "concreteType": "UserEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": (v9/*: any*/)
          }
        ]
      }
    ],
    "argumentDefinitions": ([]/*: any*/)
  }
],
v12 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v13 = [
  {
    "kind": "Variable",
    "name": "workspaceId",
    "variableName": "workspaceId"
  }
],
v14 = {
  "kind": "ScalarField",
  "name": "id"
},
v15 = [
  (v8/*: any*/),
  (v14/*: any*/)
],
v16 = {
  "kind": "ScalarField",
  "name": "name"
},
v17 = {
  "kind": "ScalarField",
  "name": "picture"
},
v18 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v19 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v20 = {
  "kind": "ScalarField",
  "name": "count"
},
v21 = {
  "kind": "ScalarField",
  "name": "key"
},
v22 = {
  "kind": "ScalarField",
  "name": "value"
},
v23 = {
  "kind": "ScalarField",
  "name": "targetDate"
},
v24 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v25 = {
  "kind": "ScalarField",
  "name": "watching"
},
v26 = {
  "kind": "ScalarField",
  "name": "archived"
},
v27 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v28 = {
  "concreteType": "UserPII",
  "kind": "LinkedField",
  "name": "pii",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    (v16/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/),
    {
      "concreteType": "ExtendedProfile",
      "kind": "LinkedField",
      "name": "extendedProfile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "jobTitle"
        }
      ]
    }
  ]
},
v29 = [
  (v8/*: any*/),
  (v28/*: any*/),
  (v14/*: any*/)
],
v30 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": "connectionId",
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v31 = [
  (v14/*: any*/)
],
v32 = {
  "kind": "InlineFragment",
  "selections": (v31/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v33 = {
  "kind": "ScalarField",
  "name": "type"
},
v34 = [
  (v20/*: any*/)
],
v35 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": "connId",
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v36 = {
  "kind": "ScalarField",
  "name": "label"
},
v37 = {
  "concreteType": "LocalizationField",
  "kind": "LinkedField",
  "name": "localizedLabel",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "messageId"
    }
  ]
},
v38 = {
  "kind": "ScalarField",
  "name": "url"
},
v39 = {
  "kind": "ScalarField",
  "name": "description"
},
v40 = {
  "kind": "LinkedField",
  "name": "definition",
  "plural": false,
  "selections": [
    (v27/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v16/*: any*/),
        (v39/*: any*/)
      ],
      "type": "CustomFieldDefinitionNode",
      "abstractKey": "__isCustomFieldDefinitionNode"
    },
    (v32/*: any*/)
  ]
},
v41 = {
  "kind": "InlineFragment",
  "selections": [
    (v33/*: any*/)
  ],
  "type": "CustomFieldDefinitionNode",
  "abstractKey": "__isCustomFieldDefinitionNode"
},
v42 = {
  "kind": "ScalarField",
  "name": "canSetMultipleValues"
},
v43 = [
  (v42/*: any*/)
],
v44 = {
  "kind": "InlineFragment",
  "selections": (v43/*: any*/),
  "type": "UserCustomFieldDefinition"
},
v45 = {
  "kind": "InlineFragment",
  "selections": (v43/*: any*/),
  "type": "TextSelectCustomFieldDefinition"
},
v46 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "LinkedField",
      "name": "definition",
      "plural": false,
      "selections": [
        (v41/*: any*/),
        (v44/*: any*/),
        (v45/*: any*/)
      ]
    }
  ],
  "type": "CustomFieldNode",
  "abstractKey": "__isCustomFieldNode"
},
v47 = [
  (v14/*: any*/),
  (v22/*: any*/)
],
v48 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v49 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ProjectViewAsideQuery",
    "selections": [
      {
        "condition": "isNavRefreshEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "project",
            "args": (v7/*: any*/),
            "concreteType": "Project",
            "kind": "LinkedField",
            "name": "projectByKey",
            "plural": false,
            "selections": [
              {
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": (v9/*: any*/)
              },
              (v10/*: any*/),
              {
                "concreteType": "UserConnection",
                "kind": "LinkedField",
                "name": "members",
                "plural": false,
                "selections": (v11/*: any*/)
              },
              {
                "concreteType": "UserConnection",
                "kind": "LinkedField",
                "name": "watchers",
                "plural": false,
                "selections": (v11/*: any*/)
              },
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "areMilestonesEnabled",
                    "variableName": "areMilestonesEnabled"
                  },
                  (v12/*: any*/),
                  (v6/*: any*/)
                ],
                "kind": "FragmentSpread",
                "name": "ProjectSidebar"
              }
            ]
          }
        ]
      },
      {
        "args": (v13/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": (v9/*: any*/)
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProjectViewAsideQuery",
    "selections": [
      {
        "args": (v13/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": (v15/*: any*/)
      },
      {
        "condition": "isNavRefreshEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "project",
            "args": (v7/*: any*/),
            "concreteType": "Project",
            "kind": "LinkedField",
            "name": "projectByKey",
            "plural": false,
            "selections": [
              {
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v14/*: any*/),
                  {
                    "concreteType": "UserPII",
                    "kind": "LinkedField",
                    "name": "pii",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "email"
                      },
                      (v19/*: any*/)
                    ]
                  }
                ]
              },
              (v10/*: any*/),
              {
                "concreteType": "UserConnection",
                "kind": "LinkedField",
                "name": "members",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "UserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v15/*: any*/)
                      }
                    ]
                  },
                  (v20/*: any*/)
                ]
              },
              {
                "concreteType": "UserConnection",
                "kind": "LinkedField",
                "name": "watchers",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "UserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v14/*: any*/),
                          {
                            "concreteType": "UserPII",
                            "kind": "LinkedField",
                            "name": "pii",
                            "plural": false,
                            "selections": [
                              (v16/*: any*/),
                              (v17/*: any*/),
                              (v19/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v20/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "ari"
              },
              (v14/*: any*/),
              (v21/*: any*/),
              {
                "concreteType": "ProjectState",
                "kind": "LinkedField",
                "name": "state",
                "plural": false,
                "selections": [
                  (v22/*: any*/),
                  {
                    "concreteType": "CompletionProjectState",
                    "kind": "LinkedField",
                    "name": "atCompletionState",
                    "plural": false,
                    "selections": [
                      (v22/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "creationDate"
              },
              {
                "kind": "ScalarField",
                "name": "startDate"
              },
              (v23/*: any*/),
              {
                "kind": "ScalarField",
                "name": "targetDateConfidence"
              },
              (v24/*: any*/),
              (v25/*: any*/),
              (v16/*: any*/),
              (v26/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canEditMembers"
              },
              {
                "concreteType": "ContributorConnection",
                "kind": "LinkedField",
                "name": "contributors",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ContributorEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v27/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v29/*: any*/),
                            "type": "User"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v14/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "teamId"
                              },
                              (v16/*: any*/),
                              {
                                "concreteType": "TeamDetails",
                                "kind": "LinkedField",
                                "name": "teamDetails",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "isVerified"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "membershipSettings"
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "avatarUrl"
                              },
                              (v25/*: any*/),
                              {
                                "args": [
                                  (v12/*: any*/)
                                ],
                                "kind": "ScalarField",
                                "name": "permission"
                              },
                              {
                                "args": [
                                  (v6/*: any*/)
                                ],
                                "concreteType": "UserConnection",
                                "kind": "LinkedField",
                                "name": "membersOfProject",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "UserEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "User",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v29/*: any*/)
                                      }
                                    ]
                                  },
                                  (v30/*: any*/)
                                ]
                              }
                            ],
                            "type": "Team"
                          },
                          (v32/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v30/*: any*/)
                ]
              },
              {
                "concreteType": "GoalConnection",
                "kind": "LinkedField",
                "name": "goals",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GoalEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Goal",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          {
                            "concreteType": "GoalIcon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "appearance"
                              }
                            ]
                          },
                          {
                            "concreteType": "GoalProgress",
                            "kind": "LinkedField",
                            "name": "progress",
                            "plural": false,
                            "selections": [
                              (v33/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "percentage"
                              }
                            ]
                          },
                          {
                            "concreteType": "MetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "MetricTargetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "MetricTarget",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "MetricValue",
                                        "kind": "LinkedField",
                                        "name": "snapshotValue",
                                        "plural": false,
                                        "selections": [
                                          (v22/*: any*/),
                                          (v14/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "startValue"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "targetValue"
                                      },
                                      {
                                        "concreteType": "Metric",
                                        "kind": "LinkedField",
                                        "name": "metric",
                                        "plural": false,
                                        "selections": [
                                          (v33/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "subType"
                                          },
                                          (v14/*: any*/),
                                          (v16/*: any*/),
                                          (v26/*: any*/)
                                        ]
                                      },
                                      (v14/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "concreteType": "GoalConnection",
                            "kind": "LinkedField",
                            "name": "subGoals",
                            "plural": false,
                            "selections": (v34/*: any*/)
                          },
                          (v16/*: any*/),
                          (v21/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v35/*: any*/)
                ]
              },
              {
                "concreteType": "ProjectDependencyConnection",
                "kind": "LinkedField",
                "name": "dependencies",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ProjectDependencyEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "ProjectDependency",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "linkType"
                          },
                          {
                            "concreteType": "Project",
                            "kind": "LinkedField",
                            "name": "outgoingProject",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              (v14/*: any*/),
                              (v16/*: any*/),
                              (v24/*: any*/),
                              (v10/*: any*/),
                              {
                                "concreteType": "IconURIs",
                                "kind": "LinkedField",
                                "name": "iconUrl",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "ThemeURIs",
                                    "kind": "LinkedField",
                                    "name": "square",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "light"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "dark"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "transparent"
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "concreteType": "ProjectState",
                                "kind": "LinkedField",
                                "name": "state",
                                "plural": false,
                                "selections": [
                                  (v36/*: any*/),
                                  (v37/*: any*/),
                                  {
                                    "alias": "projectStateValue",
                                    "kind": "ScalarField",
                                    "name": "value"
                                  },
                                  {
                                    "concreteType": "CompletionProjectState",
                                    "kind": "LinkedField",
                                    "name": "atCompletionState",
                                    "plural": false,
                                    "selections": [
                                      (v22/*: any*/),
                                      (v36/*: any*/),
                                      (v37/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "alias": "dependencyId",
                            "kind": "ScalarField",
                            "name": "id"
                          },
                          {
                            "concreteType": "Project",
                            "kind": "LinkedField",
                            "name": "incomingProject",
                            "plural": false,
                            "selections": (v31/*: any*/)
                          },
                          (v14/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v35/*: any*/)
                ]
              },
              {
                "alias": "workTrackingLinks",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  },
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "WORK_TRACKING"
                  }
                ],
                "concreteType": "LinkConnection",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "LinkEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Link",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v38/*: any*/),
                          (v16/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v35/*: any*/)
                ],
                "storageKey": "links(first:1,type:\"WORK_TRACKING\")"
              },
              {
                "concreteType": "FusionDetails",
                "kind": "LinkedField",
                "name": "fusion",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "synced"
                  }
                ]
              },
              {
                "concreteType": "Workspace",
                "kind": "LinkedField",
                "name": "workspace",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "Site",
                    "kind": "LinkedField",
                    "name": "site",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "ProductActivationConnection",
                        "kind": "LinkedField",
                        "name": "productActivations",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "ProductActivationEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v27/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "atlasForJiraCloudEnabled"
                                      }
                                    ],
                                    "type": "JiraProductActivation"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v14/*: any*/)
                ]
              },
              {
                "alias": "relatedLinks",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "RELATED"
                  }
                ],
                "concreteType": "LinkConnection",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "LinkEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Link",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v16/*: any*/),
                          (v38/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v35/*: any*/)
                ],
                "storageKey": "links(type:\"RELATED\")"
              },
              {
                "alias": "milestoneCount",
                "concreteType": "MilestoneConnection",
                "kind": "LinkedField",
                "name": "milestones",
                "plural": false,
                "selections": (v34/*: any*/)
              },
              {
                "concreteType": "TagConnection",
                "kind": "LinkedField",
                "name": "tags",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TagEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Tag",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v24/*: any*/),
                          (v16/*: any*/),
                          (v39/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "projectUsageCount"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "goalUsageCount"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "helpPointerUsageCount"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "watcherCount"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": "tagConnectionId",
                        "kind": "ScalarField",
                        "name": "__id"
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "CustomFieldConnection",
                "kind": "LinkedField",
                "name": "customFields",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "CustomFieldEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v27/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v14/*: any*/),
                              (v40/*: any*/),
                              {
                                "concreteType": "CustomFieldTextSavedValueNode",
                                "kind": "LinkedField",
                                "name": "value",
                                "plural": false,
                                "selections": [
                                  (v14/*: any*/),
                                  {
                                    "alias": "textValue",
                                    "kind": "ScalarField",
                                    "name": "value"
                                  }
                                ]
                              },
                              (v46/*: any*/)
                            ],
                            "type": "TextCustomField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v14/*: any*/),
                              (v40/*: any*/),
                              {
                                "concreteType": "CustomFieldNumberSavedValueNode",
                                "kind": "LinkedField",
                                "name": "value",
                                "plural": false,
                                "selections": [
                                  (v14/*: any*/),
                                  {
                                    "alias": "numberValue",
                                    "kind": "ScalarField",
                                    "name": "value"
                                  }
                                ]
                              },
                              (v46/*: any*/)
                            ],
                            "type": "NumberCustomField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v14/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "definition",
                                "plural": false,
                                "selections": [
                                  (v27/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v16/*: any*/),
                                      (v39/*: any*/),
                                      (v42/*: any*/)
                                    ],
                                    "type": "UserCustomFieldDefinition"
                                  },
                                  (v32/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "UserConnection",
                                "kind": "LinkedField",
                                "name": "values",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "UserEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "User",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v14/*: any*/),
                                          (v8/*: any*/),
                                          (v28/*: any*/)
                                        ]
                                      }
                                    ]
                                  },
                                  (v30/*: any*/)
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "definition",
                                    "plural": false,
                                    "selections": [
                                      (v41/*: any*/),
                                      (v45/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "CustomFieldNode",
                                "abstractKey": "__isCustomFieldNode"
                              }
                            ],
                            "type": "UserCustomField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v14/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "definition",
                                "plural": false,
                                "selections": [
                                  (v27/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v16/*: any*/),
                                      (v39/*: any*/),
                                      (v42/*: any*/),
                                      {
                                        "concreteType": "CustomFieldTextAllowedValueConnection",
                                        "kind": "LinkedField",
                                        "name": "allowedValues",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "CustomFieldTextAllowedValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "CustomFieldTextAllowedValueNode",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": (v47/*: any*/)
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "TextSelectCustomFieldDefinition"
                                  },
                                  (v32/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "CustomFieldTextSavedValueConnection",
                                "kind": "LinkedField",
                                "name": "values",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "CustomFieldTextSavedValueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "CustomFieldTextSavedValueNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v47/*: any*/)
                                      }
                                    ]
                                  },
                                  (v30/*: any*/)
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "definition",
                                    "plural": false,
                                    "selections": [
                                      (v41/*: any*/),
                                      (v44/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "CustomFieldNode",
                                "abstractKey": "__isCustomFieldNode"
                              }
                            ],
                            "type": "TextSelectCustomField"
                          },
                          (v32/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "targetDateSet"
              },
              {
                "condition": "areMilestonesEnabled",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": (v48/*: any*/),
                    "concreteType": "MilestoneConnection",
                    "kind": "LinkedField",
                    "name": "milestones",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "MilestoneEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "Milestone",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "status"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "title"
                              },
                              (v23/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "targetDateType"
                              },
                              (v49/*: any*/),
                              (v27/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "cursor"
                          }
                        ]
                      },
                      {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "endCursor"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                          }
                        ]
                      },
                      (v49/*: any*/)
                    ],
                    "storageKey": "milestones(first:20)"
                  },
                  {
                    "args": (v48/*: any*/),
                    "handle": "connection",
                    "key": "Project__milestones",
                    "kind": "LinkedHandle",
                    "name": "milestones"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "be42ccabce85aa74ca26da1d4fb4c493",
    "id": null,
    "metadata": {},
    "name": "ProjectViewAsideQuery",
    "operationKind": "query",
    "text": "query ProjectViewAsideQuery(\n  $key: String!\n  $trackViewEvent: TrackViewEvent\n  $workspaceId: ID\n  $areMilestonesEnabled: Boolean!\n  $cloudId: String\n  $isNavRefreshEnabled: Boolean!\n) {\n  project: projectByKey(key: $key, trackViewEvent: $trackViewEvent) @include(if: $isNavRefreshEnabled) {\n    owner {\n      aaid\n      id\n    }\n    private\n    members {\n      ...utils_isUserInList\n    }\n    watchers {\n      ...utils_isUserInList\n    }\n    ...ProjectSidebar_2SVbDg\n    id\n  }\n  currentUser(workspaceId: $workspaceId) {\n    aaid\n    id\n  }\n}\n\nfragment AddOrEditButton on CustomFieldNode {\n  __isCustomFieldNode: __typename\n  id\n  definition {\n    __typename\n    ... on CustomFieldDefinitionNode {\n      __isCustomFieldDefinitionNode: __typename\n      type\n    }\n    ... on UserCustomFieldDefinition {\n      canSetMultipleValues\n    }\n    ... on TextSelectCustomFieldDefinition {\n      canSetMultipleValues\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment FollowersSidebarSection on UserConnection {\n  count\n  edges {\n    node {\n      pii {\n        name\n        picture\n        accountId\n      }\n      id\n    }\n  }\n}\n\nfragment FollowersSidebarSection_Owner on UserPII {\n  accountId\n}\n\nfragment FollowersSidebarSection_ProjectKey on Project {\n  key\n}\n\nfragment FreeformNumberField on NumberCustomField {\n  ...AddOrEditButton\n  id\n  definition {\n    __typename\n    ... on CustomFieldDefinitionNode {\n      __isCustomFieldDefinitionNode: __typename\n      name\n      description\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  value {\n    id\n    numberValue: value\n  }\n}\n\nfragment FreeformTextField on TextCustomField {\n  ...AddOrEditButton\n  id\n  definition {\n    __typename\n    ... on CustomFieldDefinitionNode {\n      __isCustomFieldDefinitionNode: __typename\n      name\n      description\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  value {\n    id\n    textValue: value\n  }\n}\n\nfragment GenericWorkTrackingLinks on Project {\n  id\n  workTrackingLinks: links(type: WORK_TRACKING, first: 1) {\n    ...ProjectLinks\n  }\n}\n\nfragment GoalItem on Goal {\n  ...PlatformGoalIcon\n  ...progressBarMetricTarget\n  ...metricTargetPopup\n  progress {\n    percentage\n  }\n  name\n  key\n  id\n}\n\nfragment InviteUserPromptPopup on Project {\n  watchers {\n    count\n  }\n}\n\nfragment LinkedGoals on Project {\n  id\n  uuid\n  goals {\n    edges {\n      node {\n        id\n        ...GoalItem\n      }\n    }\n  }\n}\n\nfragment LinkedProject on ProjectDependency {\n  dependencyId: id\n  incomingProject {\n    id\n  }\n  outgoingProject {\n    id\n    ...ProjectName_data\n    state {\n      ...ProjectState\n    }\n  }\n}\n\nfragment LinkedProjects on Project {\n  id\n  key\n  dependencies {\n    edges {\n      node {\n        linkType\n        outgoingProject {\n          key\n          id\n        }\n        ...LinkedProject\n        id\n      }\n    }\n  }\n}\n\nfragment MetaActions on Project {\n  key\n  private\n  ...ProjectStateAndTargetDate\n  ...ProjectFollowButton\n  ...InviteUserPromptPopup\n  ...ProjectActions\n}\n\nfragment MilestoneFields on Milestone {\n  id\n  title\n  targetDate\n  targetDateType\n  status\n}\n\nfragment Milestones on Project {\n  creationDate\n  startDate\n  milestones(first: 20) {\n    edges {\n      node {\n        id\n        status\n        ...MilestoneFields\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment PlatformGoalIcon on Goal {\n  icon {\n    key\n    appearance\n  }\n}\n\nfragment ProjectActions on Project {\n  id\n  name\n  archived\n  private\n}\n\nfragment ProjectContributors_OtPnR on Project {\n  id\n  name\n  key\n  canEditMembers\n  private\n  owner {\n    aaid\n    id\n  }\n  contributors {\n    edges {\n      node {\n        __typename\n        ... on User {\n          aaid\n          ...UserItem\n        }\n        ... on Team {\n          id\n          teamId\n          name\n          ...TeamAndMembersItem_OtPnR\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n  members {\n    count\n    edges {\n      node {\n        aaid\n        id\n      }\n    }\n  }\n}\n\nfragment ProjectFollowButton on Project {\n  id\n  uuid\n  watching\n}\n\nfragment ProjectIcon on Project {\n  private\n  iconUrl {\n    square {\n      light\n      dark\n      transparent\n    }\n  }\n}\n\nfragment ProjectLinks on LinkConnection {\n  edges {\n    node {\n      id\n      name\n      url\n    }\n  }\n}\n\nfragment ProjectName_data on Project {\n  id\n  key\n  name\n  uuid\n  ...ProjectIcon\n}\n\nfragment ProjectOwner on Project {\n  id\n  key\n  canEditMembers\n  owner {\n    aaid\n    pii {\n      name\n      picture\n      accountStatus\n      email\n    }\n    ...UserAvatar\n    id\n  }\n}\n\nfragment ProjectSidebar_2SVbDg on Project {\n  ari\n  id\n  key\n  ...MetaActions\n  ...ProjectOwner\n  ...ProjectContributors_OtPnR\n  ...LinkedGoals\n  ...LinkedProjects\n  ...WorkTrackingLinks\n  ...RelatedLinks\n  ...Milestones @include(if: $areMilestonesEnabled)\n  ...FollowersSidebarSection_ProjectKey\n  milestoneCount: milestones {\n    count\n  }\n  tags {\n    ...Tags\n  }\n  customFields {\n    ...SidebarFields\n  }\n  watchers {\n    ...FollowersSidebarSection\n  }\n  owner {\n    pii {\n      ...FollowersSidebarSection_Owner\n    }\n    id\n  }\n  ...ProjectStartDate\n}\n\nfragment ProjectStartDate on Project {\n  id\n  startDate\n  ...ProjectStartDatePicker\n}\n\nfragment ProjectStartDatePicker on Project {\n  startDate\n  targetDate\n  targetDateSet\n  creationDate\n  state {\n    value\n  }\n}\n\nfragment ProjectState on ProjectState {\n  label\n  localizedLabel {\n    messageId\n  }\n  projectStateValue: value\n  atCompletionState {\n    value\n    label\n    localizedLabel {\n      messageId\n    }\n  }\n}\n\nfragment ProjectStateAndTargetDate on Project {\n  state {\n    value\n    atCompletionState {\n      value\n    }\n  }\n  creationDate\n  startDate\n  targetDate\n  targetDateConfidence\n}\n\nfragment RelatedLinks on Project {\n  id\n  relatedLinks: links(type: RELATED) {\n    ...ProjectLinks\n  }\n}\n\nfragment RemoveMemberButton on User {\n  id\n  aaid\n  pii {\n    name\n  }\n}\n\nfragment SelectField on TextSelectCustomField {\n  ...AddOrEditButton\n  id\n  definition {\n    __typename\n    ... on TextSelectCustomFieldDefinition {\n      name\n      description\n      canSetMultipleValues\n      allowedValues {\n        edges {\n          node {\n            id\n            value\n          }\n        }\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  values {\n    edges {\n      node {\n        id\n        value\n      }\n    }\n  }\n}\n\nfragment SidebarFields on CustomFieldConnection {\n  edges {\n    node {\n      __typename\n      ... on TextCustomField {\n        ...FreeformTextField\n      }\n      ... on NumberCustomField {\n        ...FreeformNumberField\n      }\n      ... on UserCustomField {\n        ...UserField\n      }\n      ... on TextSelectCustomField {\n        ...SelectField\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment Tag on Tag {\n  ...Tag_createTagOption\n}\n\nfragment Tag_createTagOption on Tag {\n  id\n  name\n  uuid\n  description\n  projectUsageCount\n  goalUsageCount\n  helpPointerUsageCount\n  watcherCount\n}\n\nfragment Tags on TagConnection {\n  edges {\n    node {\n      id\n      uuid\n      name\n      ...Tag\n      ...Tag_createTagOption\n    }\n  }\n}\n\nfragment TeamAndMembersItem_OtPnR on Team {\n  ...TeamItem_OtPnR\n  name\n  id\n  teamId\n  teamDetails {\n    membershipSettings\n  }\n  permission(cloudId: $cloudId)\n  membersOfProject(key: $key) {\n    edges {\n      node {\n        aaid\n        ...UserItem\n        id\n      }\n    }\n  }\n}\n\nfragment TeamAvatar on Team {\n  id\n  name\n  teamId\n  teamDetails {\n    isVerified\n  }\n  avatarUrl\n}\n\nfragment TeamItem_OtPnR on Team {\n  id\n  name\n  teamId\n  ...TeamAvatar\n  ...TeamOptionsMenu_OtPnR\n}\n\nfragment TeamOptionsMenu_OtPnR on Team {\n  id\n  teamId\n  name\n  watching\n  permission(cloudId: $cloudId)\n  teamDetails {\n    membershipSettings\n  }\n  membersOfProject(key: $key) {\n    edges {\n      node {\n        aaid\n        ...UserItem\n        id\n      }\n    }\n  }\n}\n\nfragment UserAvatar on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n  }\n}\n\nfragment UserAvatar_1TWJ92 on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n    extendedProfile {\n      jobTitle\n    }\n  }\n}\n\nfragment UserField on UserCustomField {\n  ...AddOrEditButton\n  id\n  definition {\n    __typename\n    ... on UserCustomFieldDefinition {\n      name\n      description\n      canSetMultipleValues\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  values {\n    edges {\n      node {\n        id\n        aaid\n        ...UserAvatar_1TWJ92\n      }\n    }\n  }\n}\n\nfragment UserItem on User {\n  ...UserAvatar_1TWJ92\n  ...RemoveMemberButton\n}\n\nfragment WorkTrackingLinks on Project {\n  id\n  uuid\n  key\n  ari\n  workTrackingLinks: links(type: WORK_TRACKING, first: 1) {\n    edges {\n      node {\n        id\n        url\n      }\n    }\n  }\n  fusion {\n    synced\n  }\n  workspace {\n    site {\n      productActivations {\n        edges {\n          node {\n            __typename\n            ... on JiraProductActivation {\n              atlasForJiraCloudEnabled\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n  ...GenericWorkTrackingLinks\n}\n\nfragment metricTargetPopup on Goal {\n  id\n  progress {\n    type\n    percentage\n  }\n  subGoals {\n    count\n  }\n  metricTargets {\n    edges {\n      node {\n        ...metricTarget_direct\n        metric {\n          archived\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment metricTarget_direct on MetricTarget {\n  startValue\n  targetValue\n  snapshotValue {\n    value\n    id\n  }\n  metric {\n    id\n    name\n    type\n    subType\n    archived\n  }\n}\n\nfragment progressBarMetricTarget on Goal {\n  progress {\n    type\n    percentage\n  }\n  metricTargets {\n    edges {\n      node {\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        targetValue\n        metric {\n          type\n          subType\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment utils_isUserInList on UserConnection {\n  edges {\n    node {\n      aaid\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "198564d5c995d924a2a03d680a693eda";

export default node;
